"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeAllAdvancedCost = void 0;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const big_js_1 = __importDefault(require("big.js"));
const computeAllAdvancedCost = (lines) => groupByLogisticOffer(lines).reduce((shippingCost, line) => shippingCost.add(calculateAdvancedRulesCostForLine(line.rules, line.informations)), (0, big_js_1.default)(0));
exports.computeAllAdvancedCost = computeAllAdvancedCost;
const groupByLogisticOffer = (lines) => Object.values(lines.reduce((lineInformations, line) => {
    if (isAdvancedFeesSchedule(line.selectedLogisticOffer.feesSchedule)) {
        return {
            ...lineInformations,
            [line.selectedLogisticOffer.reference]: {
                rules: line.selectedLogisticOffer.feesSchedule.advancedRules,
                informations: buildInformations(line, lineInformations)
            }
        };
    }
    return lineInformations;
}, {}));
const buildInformations = (line, lineInformations) => {
    var _a, _b;
    return ({
        linePrice: new big_js_1.default(((_a = lineInformations[line.selectedLogisticOffer.reference]) === null || _a === void 0 ? void 0 : _a.informations.linePrice) || 0)
            .add(line.linePrice)
            .toString(),
        quantity: 1,
        weightInGrams: line.weightInGrams * line.quantity +
            (((_b = lineInformations[line.selectedLogisticOffer.reference]) === null || _b === void 0 ? void 0 : _b.informations.weightInGrams) || 0)
    });
};
const isAdvancedFeesSchedule = (feesSchedule) => (feesSchedule === null || feesSchedule === void 0 ? void 0 : feesSchedule.type) === module_logistic_interfaces_1.FeesScheduleType.Advanced && !!(feesSchedule === null || feesSchedule === void 0 ? void 0 : feesSchedule.advancedRules);
const calculateAdvancedRulesCostForLine = (advancedRules, { weightInGrams, quantity, linePrice }) => {
    const hasEqualRule = hasEquals([...advancedRules.revenue, ...advancedRules.weight]);
    const rangeWeight = calculateRangeValue(transformFeesScheduleRulesToRules(advancedRules.weight), (0, big_js_1.default)(weightInGrams).times(quantity).div(1000));
    const rangeRevenue = calculateRangeValue(transformFeesScheduleRulesToRules(advancedRules.revenue), (0, big_js_1.default)(linePrice));
    return hasEqualRule
        ? Math.min(+(rangeWeight || Infinity), +(rangeRevenue || Infinity)).toString()
        : (0, big_js_1.default)(+(rangeWeight || '0'))
            .add(rangeRevenue || '0')
            .toString();
};
const hasEquals = (rules) => rules.some(rule => rule.method === module_logistic_interfaces_1.RuleMethod.Equals);
const calculateRangeValue = (advancedRules, criterion) => {
    var _a;
    return (_a = advancedRules.find(rule => criterion.toNumber() < (rule.rangeEnd ? new big_js_1.default(rule.rangeEnd).toNumber() : Infinity) &&
        criterion.gte(rule.rangeStart))) === null || _a === void 0 ? void 0 : _a.value;
};
const transformFeesScheduleRulesToRules = (rules) => {
    let value = (0, big_js_1.default)(0);
    return rules.map(rule => {
        value =
            rule.method === module_logistic_interfaces_1.RuleMethod.Equals
                ? (0, big_js_1.default)(rule.value)
                : value.add((0, big_js_1.default)(rule.value).times(rule.method === module_logistic_interfaces_1.RuleMethod.Decrease ? -1 : 1));
        return {
            rangeStart: rule.rangeStart,
            rangeEnd: rule.rangeEnd,
            value: value.toString()
        };
    });
};
